import { Controller } from "stimulus"
import { patchRequest } from "@react/helpers/fetch"

const escape = text => String(text == null ? "" : text)
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")

export default class extends Controller {
  static targets = ["display", "editor"]

  edit(event) {
    event.preventDefault()
    if (this.editing) return

    this.editing = true
    this.fields  = JSON.parse(this.data.get("fields"))
    this.editorTarget.innerHTML = this.render()
    this.displayTarget.hidden   = true
    this.editorTarget.hidden    = false
    this.editorTarget.querySelector(".bo-field__btn--ok").addEventListener("click", event => this.save(event))
    this.editorTarget.querySelector(".bo-field__btn--cancel").addEventListener("click", event => this.cancel(event))

    this.onKey = event => {
      if (event.key === "Escape") this.cancel()
      if (event.key === "Enter" && event.target.tagName !== "SELECT") {
        event.preventDefault()
        this.save()
      }
    }
    this.editorTarget.addEventListener("keydown", this.onKey)

    const first = this.editorTarget.querySelector("input, select")
    if (first) {
      first.focus()
      if (first.select) first.select()
    }
  }

  cancel(event) {
    if (event) event.preventDefault()
    this.close()
  }

  save(event) {
    if (event) event.preventDefault()

    const values = {}
    let valid = true
    this.editorTarget.querySelectorAll("input, select").forEach(input => {
      input.classList.remove("is-invalid")
      if (input.checkValidity && !input.checkValidity()) {
        valid = false
        input.classList.add("is-invalid")
      }
      values[input.name] = input.value
    })
    if (!valid) return this.fail(this.data.get("invalid") || "Valeur invalide")

    this.busy(true)
    patchRequest({ url: this.data.get("url"), body: { field: this.data.get("field"), values } })
      .then(json => {
        if (!json.ok) return this.fail(json.error || "Enregistrement impossible")
        if (json.reload) return window.location.reload()

        this.displayTarget.querySelector("[data-value]").innerHTML = json.display
        this.fields.forEach(field => { field.value = json.values[field.name] })
        this.data.set("fields", JSON.stringify(this.fields))
        this.close()
        this.flash()
      })
      .catch(() => this.fail("Enregistrement impossible"))
      .finally(() => this.busy(false))
  }

  render() {
    const warning = this.data.get("warning")
    return [
      warning ? `<div class="bo-field__warning"><i class="fas fa-exclamation-triangle"></i> ${escape(warning)}</div>` : "",
      `<div class="bo-field__form">`,
      this.fields.map(field => this.renderField(field)).join(""),
      `<button type="button" class="bo-field__btn bo-field__btn--ok" title="Enregistrer"><i class="fas fa-check"></i></button>`,
      `<button type="button" class="bo-field__btn bo-field__btn--cancel" title="Annuler"><i class="fas fa-times"></i></button>`,
      `</div>`,
      `<div class="bo-field__error" hidden></div>`
    ].join("")
  }

  renderField(field) {
    const value = escape(field.value)
    const label = field.label ? `<span class="bo-field__label">${escape(field.label)}</span>` : ""
    const pair  = html => `<span class="bo-field__pair">${label}${html}</span>`

    if (field.type === "select") {
      const blank   = field.blank != null ? `<option value="">${escape(field.blank)}</option>` : ""
      const options = (field.options || []).map(([text, option]) =>
        `<option value="${escape(option)}" ${String(option) === String(field.value == null ? "" : field.value) ? "selected" : ""}>${escape(text)}</option>`
      ).join("")
      return pair(`<select name="${escape(field.name)}" class="form-control bo-field__input">${blank}${options}</select>`)
    }

    const attributes = [
      `name="${escape(field.name)}"`,
      `type="${escape(field.type || "text")}"`,
      `value="${value}"`,
      `class="form-control bo-field__input"`,
      field.placeholder ? `placeholder="${escape(field.placeholder)}"` : "",
      field.pattern     ? `pattern="${escape(field.pattern)}"`         : "",
      field.step        ? `step="${escape(field.step)}"`               : "",
      field.min != null ? `min="${escape(field.min)}"`                 : "",
      "autocomplete=\"off\""
    ].filter(Boolean).join(" ")
    return pair(`<input ${attributes}>`)
  }

  close() {
    this.editorTarget.removeEventListener("keydown", this.onKey)
    this.editorTarget.hidden    = true
    this.editorTarget.innerHTML = ""
    this.displayTarget.hidden   = false
    this.editing = false
  }

  fail(message) {
    const error = this.editorTarget.querySelector(".bo-field__error")
    if (!error) return
    error.textContent = message
    error.hidden = false
  }

  busy(state) {
    this.editorTarget.querySelectorAll("button, input, select").forEach(el => { el.disabled = state })
  }

  flash() {
    this.element.classList.add("bo-field--saved")
    clearTimeout(this.flashTimer)
    this.flashTimer = setTimeout(() => this.element.classList.remove("bo-field--saved"), 1500)
  }
}
